module.exports = __webpack_public_path__ + "static/media/floav.c42c177e.png";